import React from 'react';
import { Country, CountryFilters } from '../../../../app/models/Country';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import CountryFilter from './CountryFilter';
import CountrySwitchChange from '../CountrySwitchChange';

interface Props {
    countries: Country[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    destroy?: (id: number) => void;
    active?: () => void;
    filter: CountryFilters;
    setFilter: (filter: CountryFilters) => void;
}

const CountryDataTable = ({
    countries,
    totalRows,
    loading = false,
    edit,
    destroy,
    active: reloadCallback,
    filter,
    setFilter
}: Props) => {
    const columns = [
        {
            name: 'ID',
            selector: (row: Country) => row.id ?? '',
            sortable: true,
            sortField: 'id',
            width: '80px'
        },
        {
            name: 'Nombre',
            selector: (row: Country) => row.name ?? '',
            sortable: true,
            sortField: 'name'
        },
        {
            name: 'Prefijo Telefónico',
            selector: (row: Country) => row.phone_prefix ?? '',
            sortable: true,
            sortField: 'phone_prefix',
            cell: (row: Country) => <span>{row.phone_prefix ?? '-'}</span>
        },
        {
            name: 'Activo',
            selector: (row: Country) => row.is_active ?? false,
            sortable: false,
            cell: (row: Country) => (
                <CountrySwitchChange
                    countryId={row.id!}
                    checkValue={row.is_active ?? false}
                    callbackSuccess={reloadCallback}
                />
            )
        },
        {
            name: 'Acciones',
            selector: (row: Country) => row.id ?? '',
            sortable: false,
            cell: (row: Country) => (
                <div className="nowrap-cell nowrap-cell-no-min">
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id!)}
                            classIcon="mdi mdi-pencil"
                            colorIcon="text-warning"
                            errorMessage="No se puede editar este registro."
                            title="Editar"
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id!)}
                            classIcon="mdi mdi-delete"
                            colorIcon="text-danger"
                            errorMessage="No se puede eliminar este registro."
                            title="Eliminar"
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <CountryFilter filter={filter} setFilter={setFilter} />
                </div>
            </div>
            <DefaultDataTable
                columns={columns}
                data={countries}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default CountryDataTable;
